import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck, tap } from 'rxjs/operators';
const checkPincodeQuery = gql`query suburbans_aggregate($pincode: String!){
  suburbans_aggregate(where: {pincode: {_eq: $pincode}}){
	  aggregate{
      count
    }
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class CheckPincodeService {

  constructor(private apollo: Apollo) { }

  checkPincode(pincode: string){
    return this.apollo.use('external').query({
      query: checkPincodeQuery,
      variables: {
        pincode
      }
    }).pipe(tap(data=>{
      console.log(data);
    }),pluck('data', 'suburbans_aggregate','aggregate','count')).toPromise();
  }
}
